module.exports = __webpack_public_path__ + "static/media/icon-yellowTriangleS.09eaa526.svg";